const $inject = [];
const lbaReasonForTravelSelect = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<'
    },
    bindToController: true,
    controller: 'lbaReasonForTravelSelectCtrl',
    controllerAs: 'vm',
    template: require('./lbaReasonForTravelSelect.html')
  }
};

lbaReasonForTravelSelect.$inject = $inject;

export default lbaReasonForTravelSelect;



// WEBPACK FOOTER //
// ./src/components/lbaReasonForTravelSelect/lbaReasonForTravelSelectDir.js